<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="拍品名称">
        <a-input type="text" style="width: 600px" v-model="form.name"></a-input>
      </a-form-item>

      <a-form-item label="封面图片">
        <UploadFile @callback="uploaded" :mult="false" folder="tuanpai" />
        <a-input
          style="width: 600px"
          placeholder="请输入图片地址"
          v-model="form.thumb"
        />
      </a-form-item>

      <a-form-item label="更多图片">
        <UploadFile @callback="uploaded2" :mult="true" folder="tuanpai" />
      </a-form-item>

      <a-form-item label="拍品编号">
        <a-input type="text" style="width: 600px" v-model="form.sn"></a-input>
      </a-form-item>

      <a-form-item label="起拍价">
        <a-input-number :min="0" v-model="form.price" /> 元
      </a-form-item>

      <a-form-item label="赢家限量">
        <a-input-number :min="1" v-model="form.winner_q" />
      </a-form-item>

      <a-form-item label="拍品介绍">
        <Editor @callback="updateEditor" :data="form.desc" folder="tuanpai" />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">添加拍品</a-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import UploadFile from "../../../components/uploadFile.vue";
import Editor from "../../../components/editor";

export default {
  components: { UploadFile, Editor },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      form: {
        auc_id: null,
        name: "",
        thumb: "",
        imgs: [],
        sn: "",
        price: 1,
        desc: "",
        winner_q: 1,
      },
    };
  },
  created() {
    this.form.auc_id = this.$route.query.auc_id;
  },
  methods: {
    moment,
    uploaded(file) {
      this.form.thumb = file.file_path;
    },
    uploaded2(files) {
      this.form.imgs = files;
    },
    updateEditor(data) {
      this.form.desc = data;
    },
    async sub() {
      if (!this.form.name) return this.$message.error("请填写拍品名称");
      if (!this.form.thumb) return this.$message.error("请上传封面图片");
      if (!this.form.price) return this.$message.error("请填写起拍价");
      if (!this.form.winner_q) return this.$message.error("请填写赢家限量");

      const r = await this.$axios.post("/tuanpai/goods/create", this.form);

      if (r.status == 1) {
        this.$router.back();
      }
    },
  },
};
</script>